<burncase-loading *ngIf="drawViewService.isLoading && !applicationService.appStarted"></burncase-loading>
<div style="width: 100%; height: 100%;">
    <burncase-navigation (drawView)="activateMode($event)"></burncase-navigation>
    <div [ngSwitch]="(isHandset$|async)">
        <div *ngSwitchCase="false">
            <div [ngSwitch]="applicationService.mode">
                <burncase-brush-settings *ngSwitchCase="'brushMode'" @settings
                                         class="centered">
                </burncase-brush-settings>
                <burncase-measuring *ngSwitchCase="'measureMode'" @settings class="left"></burncase-measuring>
                <burncase-info *ngSwitchCase="'infoMode'" @settings class="left"></burncase-info>
            </div>
        </div>
        <div *ngSwitchCase="true">
            <div [ngSwitch]="applicationService.mode">
                <burncase-measuring *ngSwitchCase="'measureMode'" @settings class="left"></burncase-measuring>
                <burncase-info *ngSwitchCase="'infoMode'" @settings class="left"></burncase-info>
            </div>
        </div>
    </div>
</div>


